export const localization = {
  pt: {
    title: 'Importar arquivo',
    subtitle:
      'Importe manuais, guias e artigos para criar uma base de conhecimento para seu agente. Saiba como formatar a base de conteúdo.',
    fileUpload: {
      title: 'Importar arquivos',
      subtitle: 'Você pode enviar arquivos nos formatos XLSX, CSV, PDF, TXT, DOCX e PPTX',
    },
    cancelButton: 'Cancelar',
    saveButton: 'Salvar',
    successToast: {
      title: 'Conteúdo adicionado',
      message: 'O conteúdo foi salvo e está disponível no catálogo.',
    },
    errorToast: {
      title: 'Falha ao adicionar o conteúdo',
      message: 'Não foi possível salvar o conteúdo. Tente novamente.',
    },
  },
  en: {
    title: 'Import file',
    subtitle:
      'Import manuals, guides, and articles to create a knowledge base for your agent. Learn how to format the content base.',
    fileUpload: {
      title: 'Import files',
      subtitle: 'You can upload files in XLSX, CSV, PDF, TXT, DOCX and PPTX formats',
    },
    cancelButton: 'Cancel',
    saveButton: 'Save',
    successToast: {
      title: 'Content added',
      message: 'The content has been saved and is available in the catalog.',
    },
    errorToast: {
      title: 'Could not add content',
      message: 'Could not save the content. Please try again.',
    },
  },
  es: {
    title: 'Importar archivo',
    subtitle:
      'Importa manuales, guías y artículos para crear una base de conocimiento para tu agente. Aprende cómo formatear la base de contenido.',
    fileUpload: {
      title: 'Importar archivos',
      subtitle: 'Puedes enviar archivos en formatos XLSX, CSV, PDF, TXT, DOCX y PPTX',
    },
    cancelButton: 'Cancelar',
    saveButton: 'Salvar',
    successToast: {
      title: 'Contenido agregado',
      message: 'El archivo se ha importado correctamente y está siendo procesado.',
    },
    errorToast: {
      title: 'Fallo al agregar el contenido',
      message: 'No se pudo importar el archivo. Inténtalo de nuevo.',
    },
  },
};
